export default __webpack_public_path__ + "static/media/driveability_green.33416ae6.svg";